import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRight, BookOpen, CheckCircle } from 'lucide-react';
import { Button } from './ui/Button';
import { SectionWrapper } from './ui/SectionWrapper';
export function Hero() {
  return <div className="relative overflow-hidden bg-slate-900 pt-16 pb-20 lg:pt-24 lg:pb-28" data-id="element-169">
      {/* Background Pattern */}
      <div className="absolute inset-0 z-0 opacity-20" data-id="element-170">
        <div className="absolute -top-24 -left-24 h-96 w-96 rounded-full bg-emerald-500 blur-3xl" data-id="element-171" />
        <div className="absolute top-1/2 right-0 h-96 w-96 rounded-full bg-blue-600 blur-3xl" data-id="element-172" />
      </div>

      <SectionWrapper background="navy" className="relative z-10 !py-0" data-id="element-173">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-8 items-center" data-id="element-174">
          {/* Left Column: Text */}
          <motion.div initial={{
          opacity: 0,
          x: -20
        }} animate={{
          opacity: 1,
          x: 0
        }} transition={{
          duration: 0.6
        }} data-id="element-175">
            <h1 className="text-4xl md:text-5xl lg:text-6xl font-extrabold text-white tracking-tight leading-tight mb-6" data-id="element-176">
              Aprende Amazon FBA{' '}
              <span className="text-emerald-400" data-id="element-177">paso a paso</span> y vende en
              Amazon.com
            </h1>
            <p className="text-lg md:text-xl text-slate-300 mb-8 max-w-2xl leading-relaxed" data-id="element-178">
              Guía práctica en español: Private Label, Wholesale y Arbitraje.
              Incluye costos reales, proveedores, checklists y plan de 30 días.
            </p>

            <div className="flex flex-col sm:flex-row gap-4 mb-8" data-id="element-179">
              <Button size="lg" className="group" data-id="element-180">
                Comprar ahora
                <ArrowRight className="ml-2 h-5 w-5 group-hover:translate-x-1 transition-transform" data-id="element-181" />
              </Button>
              <Button variant="outline" size="lg" className="border-slate-600 text-slate-200 hover:bg-white/10 hover:text-white hover:border-white" data-id="element-182">
                Ver índice
                <BookOpen className="ml-2 h-5 w-5" data-id="element-183" />
              </Button>
            </div>

            <div className="flex flex-wrap gap-4 text-sm text-slate-400" data-id="element-184">
              <div className="flex items-center" data-id="element-185">
                <CheckCircle className="h-4 w-4 text-emerald-500 mr-2" data-id="element-186" />
                60+ páginas prácticas
              </div>
              <div className="flex items-center" data-id="element-187">
                <CheckCircle className="h-4 w-4 text-emerald-500 mr-2" data-id="element-188" />
                Plantillas copiables
              </div>
              <div className="flex items-center" data-id="element-189">
                <CheckCircle className="h-4 w-4 text-emerald-500 mr-2" data-id="element-190" />
                Ejemplos numéricos
              </div>
            </div>
          </motion.div>

          {/* Right Column: Book Mockup */}
          <motion.div initial={{
          opacity: 0,
          x: 20
        }} animate={{
          opacity: 1,
          x: 0
        }} transition={{
          duration: 0.8,
          delay: 0.2
        }} className="flex justify-center lg:justify-end perspective-1000" data-id="element-191">
            <div className="relative w-64 h-80 md:w-80 md:h-[450px] bg-gradient-to-br from-slate-800 to-slate-900 rounded-r-2xl rounded-l-sm shadow-2xl transform rotate-y-12 hover:rotate-y-0 transition-transform duration-500 border-r-4 border-slate-700 flex flex-col items-center justify-center p-8 text-center border-l-8 border-l-slate-800" data-id="element-192">
              {/* Book Spine Effect */}
              <div className="absolute left-0 top-0 bottom-0 w-2 bg-gradient-to-r from-slate-700 to-slate-600 opacity-50" data-id="element-193" />

              {/* Cover Content */}
              <div className="w-full h-full border-2 border-white/10 rounded-lg p-6 flex flex-col justify-between relative overflow-hidden group" data-id="element-194">
                <div className="absolute inset-0 bg-gradient-to-br from-emerald-500/10 to-blue-500/10" data-id="element-195" />

                <div className="relative z-10" data-id="element-196">
                  <div className="text-emerald-400 text-xs font-bold tracking-widest uppercase mb-2" data-id="element-197">
                    Guía 2026
                  </div>
                  <h2 className="text-3xl font-bold text-white mb-1" data-id="element-198">
                    AMAZON FBA
                  </h2>
                  <h3 className="text-xl font-light text-slate-300" data-id="element-199">
                    DESDE CERO
                  </h3>
                </div>

                <div className="relative z-10" data-id="element-200">
                  <div className="w-12 h-12 bg-emerald-500 rounded-full flex items-center justify-center mx-auto mb-4 shadow-lg shadow-emerald-500/30" data-id="element-201">
                    <ArrowRight className="text-white h-6 w-6 -rotate-45" data-id="element-202" />
                  </div>
                  <p className="text-xs text-slate-400" data-id="element-203">
                    Private Label • Wholesale • Arbitraje
                  </p>
                </div>
              </div>

              {/* Shadow */}
              <div className="absolute -bottom-12 left-4 right-4 h-8 bg-black/40 blur-xl rounded-full" data-id="element-204" />
            </div>
          </motion.div>
        </div>
      </SectionWrapper>
    </div>;
}